/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Settings_TitleInputs */



/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Options_Watermark_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_settings_title = /** @type {((inputs?: Options_Watermark_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Definições")
	return /** @type {LocalizedString} */ ("Settings")
});